import './shared/global_shims';
import './shared/templates.js';
import PreviewMode from './shared/preview';
window.PreviewMode = PreviewMode;
